<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="title-container">
            <h1 class="title">
                {{
                    'system-settings.fcu.title.fcu-no'
                        | translate
                            : {
                                  num: selectedFcuUnit?.index ? selectedFcuUnit?.index : fcuUnitList.length + 1,
                              }
                }}
            </h1>
            <h2 class="sub-title"></h2>
        </div>
        <div class="button-container">
            <button
                class="text-button"
                data-cy="ops-settings-system-setting-add-edit-fcu-cancel-button"
                (click)="goBackSettingPage()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                class="new-button"
                text="system-settings.fcu.button.save"
                [disable]="disabledButton()"
                (onClick)="createFcuUnit()"
                customFontSize="14px"
                customFontFamily="NotoSans-SemiBold"></app-button>
        </div>
    </div>
    <div class="main system-setting-scroll-parent">
        <div class="side-menu" #sideMenuContainer>
            <div class="fu-status-container">
                <div
                    class="fu-add-button"
                    data-cy="ops-settings-system-setting-add-edit-fcu-add-fu-button"
                    (click)="addFuUnit()"
                    [class.disable]="fuList?.length >= FU_MAX">
                    <mat-icon svgIcon="plus"></mat-icon>
                </div>
                <div class="fu-status">
                    <div class="add-fu-text">
                        {{ 'system-settings.fcu.button.add-fu' | translate }}
                    </div>
                    <div class="fu-status-text">
                        {{ 'system-settings.fu.description' | translate: { num: FU_MAX - (fuList?.length || 0) } }}
                    </div>
                </div>
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.communication' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.a-line-ip-lan' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.b-line-ip-lan' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.location' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-count' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-1' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-2' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-3' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-4' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-5' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-6' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-7' | translate }}
            </div>
            <div class="side-menu-item">
                {{ 'system-settings.fcu.sub-title.slot-8' | translate }}
            </div>
        </div>
        <div class="content" [style.height]="contentHeight">
            <div class="scroll-content system-setting-scroll-parent">
                <div class="fcu-setting-container">
                    <div class="fcu-setting-header">
                        <h4 class="title">
                            {{
                                'system-settings.fcu.title.fcu-no'
                                    | translate
                                        : {
                                              num: selectedFcuUnit?.index
                                                  ? selectedFcuUnit?.index
                                                  : fcuUnitList.length + 1,
                                          }
                            }}
                        </h4>
                        <div class="options">
                            <div #errorPopup class="error-icon" *ngIf="getIPErrors() != 0">
                                <mat-icon svgIcon="save-error" (click)="toggleError()" />
                                <div class="info-message-container" *ngIf="errorMessageVisible">
                                    <div>
                                        {{
                                            'system-settings.fcu.main.error-icon.text.' +
                                                (getIPErrors() === 1 ? 'one' : 'other') | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div (click)="openMoreOption()" #moreOptions>
                                <mat-icon class="more-icon" svgIcon="more-options"></mat-icon>
                                <div class="options-dialog" [class.show]="isOpenOption">
                                    <!-- <div
                                        class="options-item"
                                        (click)="openExternalCommunicationDialog(); $event.stopPropagation()">
                                        {{ 'system-settings.fcu.more-option.ext-comm' | translate }}
                                    </div> -->
                                    <div class="options-item" (click)="clear(); $event.stopPropagation()">
                                        {{ 'system-settings.fcu.more-option.clear' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fcu-setting-content">
                        <div class="fcu-address-container">
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-a-ops' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_LINE_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuALineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.ALineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_LINE_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuALineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.ALineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-a-fu' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_FIELD_NET_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuAFieldNetLineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.AfieldNetLineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_FIELD_NET_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuAFieldNetLineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.AfieldNetLineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-a-ceu' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_CEU_COMM_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuACeuCommLineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.AceuCommLineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_A_CEU_COMM_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuACeuCommLineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.AceuCommLineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-b-ops' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_LINE_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuBLineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BLineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_LINE_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuBLineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BLineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-b-fu' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_FIELD_NET_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuBFieldNetLineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BfieldNetLineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_FIELD_NET_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuBFieldNetLineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BfieldNetLineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                            <div class="fcu-address-inputs">
                                <div class="input-label">
                                    {{ 'system-settings.fcu.sub-title.fcu-b-ceu' | translate }}
                                </div>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_CEU_COMM_A_IP"
                                    label="system-settings.fcu.label.a-line-ip-address"
                                    [value]="fcuBCeuCommLineAIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BceuCommLineAIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                                <app-system-setting-input
                                    class="input"
                                    [name]="FCU_B_CEU_COMM_B_IP"
                                    label="system-settings.fcu.label.b-line-ip-address"
                                    [value]="fcuBCeuCommLineBIp"
                                    (onInputChange)="inputChange($event)"
                                    [inputErrorMessage]="validationErrors?.BceuCommLineBIp?.message"
                                    [maxLength]="15">
                                </app-system-setting-input>
                            </div>
                        </div>
                        <app-system-setting-input
                            class="input location"
                            [name]="LOCATION"
                            label="system-settings.fcu.label.location"
                            [value]="location"
                            (onInputChange)="inputChange($event)"
                            [inputErrorMessage]="validationErrors?.location?.message"
                            [maxLength]="16">
                        </app-system-setting-input>
                        <div class="slot-container">
                            <app-system-setting-dropdown
                                name="slotCount"
                                label="system-settings.fcu.label.slot-count"
                                [value]="selectedSlotCounter"
                                [dropdownWidth]="'68px'"
                                [disabled]="true"
                                [class.slotCountDisable]="true">
                            </app-system-setting-dropdown>
                            <app-system-setting-dropdown
                                *ngFor="let slot of slotList"
                                class="slot-dropdown"
                                [class.disable]="!slot.enable"
                                [name]="'Slot ' + slot.no"
                                [label]="getEmptySlotLabel(slot.no)"
                                [emptyItem]="EMPTY_SLOT"
                                [itemList]="FCU_SLOT_OPTIONS"
                                [value]="slot.ioType === '' ? EMPTY_SLOT : slot.ioType"
                                [selectedValues]="getSlotValue(slot)"
                                [displayEdit]="true"
                                (onInputChange)="selectSlotOption($event)"
                                [dropdownWidth]="'200px'">
                            </app-system-setting-dropdown>
                        </div>
                    </div>
                </div>
                <app-fu-setting-input-container
                    *ngFor="let fu of fuList; trackBy: trackByFu"
                    [index]="fu.index"
                    [vesselId]="fu.vesselId"
                    [location]="fu.location"
                    [selectedCommunicationType]="fu.communicationType"
                    [fieldNetLineAIp]="fu.fieldNetLineAIp"
                    [fieldNetLineBIp]="fu.fieldNetLineBIp"
                    [slotList]="fu.slotList"
                    [validationErrors]="fu.validationErrors"
                    [canCopy]="!(fuList?.length >= FU_MAX)"
                    (onChangeFuData)="changeFuData($event)"
                    (onCopyFuData)="copyFuUnit($event)"
                    (onDeleteFuData)="deleteFuUnit($event)"
                    (onClearFuData)="clearFuUnit($event)"></app-fu-setting-input-container>
                <div></div>
            </div>
        </div>
        <div class="footer-new-button">
            <div
                class="fu-add-button"
                data-cy="ops-settings-system-setting-add-edit-fcu-add-fu-button-footer"
                (click)="addFuUnit()"
                [class.disable]="fuList?.length >= FU_MAX">
                <mat-icon svgIcon="plus"></mat-icon>
            </div>
        </div>
    </div>
</div>
<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
